$(function() { 
    let variants = window.variants;
    Utils.showNavigation();    
    $(window).on( 'scroll', function(event) {
        Utils.showNavigation();
    });    
  
    $( '.tone.color' ).each(function(){
        $( '.terms .term', this ).each(function() {
            const $parent = $(this).parent();
            const $last   = $parent.children( '.term:not([data-id])' );
            let $terms = $parent.children( '.term[data-id]' );                  
            $terms.sort(function(a, b) {
                  var aValue = parseInt( $(a).data( 'id' ));
                  var bValue = parseInt( $(b).data( 'id' ));
                  return aValue - bValue;
            });                  
            $parent.html( $terms ).append( $last ); 
        });
    });

    // set current selected variant for the bag
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    setTimeout(() => {
        if ( urlParams.get( 'variant' ) ) {
            $( 'form[action*="/cart/add"]' ).find( 'select[name="id"]' ).val( urlParams.get( 'variant' ) );
            buildBuyNowButton( urlParams.get( 'variant' ) );
        }
    }, 100);

    var videosSlides = {};
    var player = null;
    var swiperProductOne = new Swiper( '.product .banner .slider.one', {
        containerModifierClass: 'slider-',
        slideActiveClass: 'active',
        slideBlankClass: 'blank',
        slideClass: 'slide',
        slideNextClass: 'next',
        slidePrevClass: 'previous',
        slideVisibleClass: 'visible',
        wrapperClass: 'slides',
        autoHeight: true,
        slidesPerGroup: 1,
        spaceBetween: 35,
        watchOverflow: true,
        loop: $( '.product .banner .slider .slides .slide' ).length != 1,
        navigation: {
            disabledClass: 'disabled',
            nextEl: '.product .banner .slider .button.next',
            prevEl: '.product .banner .slider .button.previous',
        },
        pagination: {
            bulletClass: 'icon',
            bulletActiveClass: 'active',
            el: '.product .overview .pagination',
        },
        zoom: {
            containerClass: 'content',
            maxRatio: 1.75,
            minRatio: 1,
            zoomedSlideClass: 'magnify'
        },                
        breakpoints: {
            0: {
                speed: 400,
            },
            1025: {
                speed: 800,
            }
        }
    });   

    var swiperProductThree = new Swiper( '.related:not(.hidden) .slider', {
        containerModifierClass: 'slide-',
        noSwipingClass: 'alt',
        slideActiveClass: 'active',
        slideBlankClass: 'blank',
        slideClass: 'slide',
        slideNextClass: 'next',
        slidePrevClass: 'previous',
        slideVisibleClass: 'visible',
        wrapperClass: 'slides',
        speed: 750,
        navigation: {
            disabledClass: 'disabled',
            nextEl: '.related .slider .buttons .next',
            prevEl: '.related .slider .buttons .previous',
        },
        breakpoints: {
            300: {
                spaceBetween: 12,
                slidesPerView: 2
            },
            600: {
                spaceBetween: 17,
                slidesPerView: 3
            },
            900: {
                spaceBetween: 22,
                slidesPerView: 4
            }
        }
    });

    if ( ! window.selectedPaint ) {
        $( '.product .banner' ).removeClass( 'hidden' );
    }

    if ( $( '.product .overview .content .blocks.three .attributes .attribute' ).length == 0 ) {
         $( '.product .overview .content .blocks.three .attributes' ).addClass( 'alt' );
    }

    $( '.product-form .attribute.size .term' ).click(function() {
        const redirect = $( 'a', this ).attr( 'href' );
        if ( redirect ) {
            location.href = redirect;
            return;
        }                        
        if ( $( '.product-form .attribute.weight' ).length ) {
            let colour  = $( '.product-form .attribute.color .text.product-form__selected-value' ).text();
            let size    = $(this).attr( 'value' );                  
            let $weight = $( '.product-form .attribute.weight .term:not(.hidden).selected' );
            if ( ! $weight ) {
                $weight = $( '.product-form .attribute.weight .term:visible' ).first();
            }
            let weight = $weight.attr( 'value' );
            let index = variants.findIndex( item => item.options.includes( colour ) && item.options.includes( size ) && item.options.includes( weight ));
            let other_variants = variants.filter(item => item.options.includes( colour ) && item.options.includes( size ));  
            let variant = index != -1 ? variants[index] : other_variants[0];
            updateBanner( variant );
            $( '.product-form .attribute.weight .term' ).addClass( 'hidden' );
            other_variants.forEach(item => {
                $( '.product-form .attribute.weight .term[data-variant_id="' + item.id + '"]' ).removeClass( 'hidden' );
            });
            $( '.product-form .attribute.weight .term' ).removeClass( 'selected' );
            $( '.product-form .attribute.weight .term[data-variant_id="' + variant.id + '"]' ).addClass( 'selected' );
            $( '.product-form .attribute.size .text.product-form__selected-value' ).text( size );
            $(this).closest( 'product-form' ).find( 'input[name="product-id"]' ).val( variant.id );
        } else {
            if ( $(this).attr( 'value' ).includes( 'Shaped' ) ) {
                $( '.product .overview .content .form .blocks.three .block .fields .attributes .attribute.size .content .select.alt .text' ).text( $(this).attr( 'value' ) );
            }
            let variant_id = $(this).data( 'variant_id' );
            let variant = variants.filter(item => item.id == variant_id)[0];
            updateBanner( variant );
            $( '.size.paint .terms .term' ).removeClass( 'selected' );
            $(this).addClass( 'selected' );
        }              
    });

    $( '.product .overview .content form .fields .attributes .attribute.size .content .select.alt' ).click(function() {
        // if ( $( '.product-form .attribute.weight.alt' ).length ) {
        //     return false;
        // }
        let $modal = $( '.product-form .attribute.size .modal' );
        if ( ! $modal.length ) {
            return false;
        }
        let colour  = $( '.product-form .attribute.color .text.product-form__selected-value' ).text();          
        let $weight = $( '.product-form .attribute.weight .term:not(.hidden).selected' );
        if ( ! $weight ) {
            $weight = $( '.product-form .attribute.weight .term:visible' ).first();
        }
        let weight = $weight.attr( 'value' );

        $modal.find( '.terms .term' ).each(function() {
            let size = $(this).attr( 'value' );
            let index = variants.findIndex(item => item.options.includes(colour) && item.options.includes(weight) && item.options.includes(size));
            if ( index >= 0 ) {
                let price = window.theme.currencySymbol + ( variants[index].price / 100 ).toString();
                if ( ! $( '.price', this ).length ) {
                    $( '.text', this ).after( `<div class="price">${price}</div>` );
                } else {
                    $(this).find( '.price' ).text( price );
                }
            }
        });            
    });

    $( '.product .overview .content form .fields .attributes .attribute.colour.grout .content .select.alt' ).click(function() {
        
        // if ( $( '.product-form .attribute.weight.alt' ).length ) {
        //     return false;
        // }
        let $modal = $( '.product-form .attribute.colour.grout .modal' );
        if ( ! $modal.length ) {
            return false;
        }
        let colour  = $( '.product-form .attribute.colour.grout .text.product-form__selected-value' ).text();          
        let $weight = $( '.product-form .attribute.weight .term:not(.hidden).selected' );
        if ( ! $weight ) {
            $weight = $( '.product-form .attribute.weight .term:visible' ).first();
        }
        let weight = $weight.attr( 'value' );

        $modal.find( '.terms .term' ).each(function() {
            let size = $(this).attr( 'value' );
            let index = variants.findIndex(item => item.options.includes(colour) && item.options.includes(weight) && item.options.includes(size));
            if ( index >= 0 ) {
                let price = window.theme.currencySymbol + ( variants[index].price / 100 ).toString();
                if ( ! $( '.price', this ).length ) {
                    $( '.text', this ).after( `<div class="price">${price}</div>` );
                } else {
                    $(this).find( '.price' ).text( price );
                }
            }
        });            
    });
    
    $( '.product-form .attribute.weight .term' ).click(function() {
        if ( ! $( 'a', this ).length ) {
            $( '.product-form .attribute.weight .term' ).removeClass( 'selected' );
            $(this).addClass( 'selected' );
            let variant_id = $(this).data( 'variant_id' );
            let variant = variants.filter(variant => variant.id == variant_id )[0];
            updateBanner( variant );
            let weight = variant.option3;
            if ( ! weight ) {
                weight = variant.option2;
            }
            setTimeout(() => {
                $('.product .weight .select.alt .text').text( weight );  
            }, 1);                      
        }
    });

    if ( window.isShaped ) {
        $( '.attribute.color .modal .tone .term' ).click(function(e) {
            let variant = variants[ $(this).data( 'variant-pos' ) ];
            if ( variant.available ) {
                $( '#add-to-bag' ).removeAttr( 'disabled' ).removeClass( 'disabled' ).find( '.text' ).text( 'Add To Bag' );   
            } else {
                $( '#add-to-bag' ).attr( 'disabled', true ).addClass( 'disabled' ).find( '.text' ).text( 'Sold Out' ); 
            }
        });
    }
    
    if ( $( '.product-form .attribute.weight .term' ).length ) {                    
        setDefaultWeights();
    } else if ( window.selectedVariant ) {
        updateBanner( window.selectedVariant );
        $( '.product-form .attribute.size .term[data-variant_id="' + window.selectedVariant.id + '"]' ).addClass( 'selected' ); 
    }

    $(document).on( 'click', '.product .banner .content .slider .slides .slide .overlay', function() {
        $( "meta[name='theme-color']" ).attr( 'content', '#FEFEFE' );
        $( 'body' ).addClass( 'overflow' );
        $( '.product .banner' ).addClass( 'active' );
    });

    $( '.product .banner .content .close' ).click(function() {
        $( "meta[name='theme-color']" ).attr( 'content', '#101820' );
        $( 'body' ).removeClass( 'overflow' );
        $( '.product .banner' ).removeClass( 'active' );
    });

    $( '.product .banner .content .slider .button.zoom .button.circle.alt.zoom-in' ).click(function() {
        swiperProductOne.zoom.in();
    });

    $( '.product .banner .content .slider .button.zoom .button.circle.alt.zoom-out' ).click(function() {
        swiperProductOne.zoom.out();
    });

    swiperProductOne.on( 'slideChangeTransitionEnd', function() {
        const _this = $(this);
        const $slide = $( _this[0].slides[_this[0].activeIndex] );
        if ( $slide.hasClass( 'video' ) ) {
            $( '.product .banner .content .slider .button.video' ).removeClass( 'one' );
            $( '.product .banner .content .slider .button.video' ).addClass( 'two' );
            let variant_id = $slide.data( 'variant_id' );
            let id = variant_id + '-' + _this[0].activeIndex;
            let variant = variants.find(item => item.id == variant_id);
            if ( variant.videos.length > 1 ) {
                const videoIndex = variant.videos.findIndex(item => item.replace(/&amp;/g, '&') == $slide.find('iframe')[0].src);
                if ( $(document).find( '.product .banner .slider .button.video .button.alt.number' ).length == 0 ) {
                    $( '.product .banner .slider .button.video' ).append( 
                        `<div class="button small alt number">    
                            <a>    
                                <div class="icon">    
                                    <i class="icons8 icons8-circled-play"></i>    
                                </div>    
                                <div class="text">Video 1 of ${variant.videos.length}</div>    
                                <div class="background"></div>    
                            </a>    
                        </div>` 
                    );
                } else {
                    $(document).find( '.product .banner .slider .button.video .button.alt.number .text' ).text( `Video ${( videoIndex + 1 )}  of ${variant.videos.length}` );
                }
            }
            if ( ! ( id in videosSlides ) ) {
                player = new playerjs.Player( $slide.find('iframe')[0] );
                videosSlides[id] = player;                 
            } else {
                player = videosSlides[id];
            }         
            player.on('ready', () => {
                player.play();
                player.mute();
            });
          
            const $previousSlide = $( _this[0].slides[_this[0].previousIndex] );
            const previous_id = $previousSlide.data( 'variant_id' ) + '-' + _this[0].previousIndex;
            if ( previous_id in videosSlides ) {
                videosSlides[previous_id].on('ready', () => videosSlides[previous_id].pause());
            } 
            $( '.product .banner .content .slider .button.video' ).removeClass( 'unmute' );
            $( '.product .banner .content .slider .button.video' ).addClass( 'mute' );
        } else {
            $( '.product .banner .content .slider .button.video' ).removeClass( 'two' );
            $( '.product .banner .content .slider .button.video' ).addClass( 'one' );
            $(document).find( '.product .banner .slider .button.video .button.alt.number' ).remove();
        }
    });

    $(document).on( 'click', '.product .banner .content .slider .button.video .button.small.alt.number', function() {
        swiperProductOne.slideNext();
    });

    $( '.product .banner .content .slider .button.video .button.small.alt.view' ).click(function(e) {
        swiperProductOne.slideTo( swiperProductOne.slides.findIndex(item => $(item).hasClass( 'video' ) && ! $(item).hasClass( 'last' )), 0 );
    });

    $( '.product .banner .content .slider .button.video .button.small.alt.unmute' ).click(function(e) {
        $( '.product .banner .content .slider .button.video' ).removeClass( 'mute' );
        $( '.product .banner .content .slider .button.video' ).addClass( 'unmute' );
        player.unmute();
    });

    $( '.product .banner .content .slider .button.video .button.small.alt.mute' ).click(function(e) {
        $( '.product .banner .content .slider .button.video' ).removeClass( 'unmute' );
        $( '.product .banner .content .slider .button.video' ).addClass( 'mute' );               
        player.mute();
    });

    function setDefaultWeights() {
        let colour  = $( '.product-form .attribute.color .text.product-form__selected-value' ).text();
        let size    = $( '.product-form .attribute.size:not(.grout.colour) .term.selected' ).attr( 'value' );
        if ( ! size ) {
            $( '.product-form .attribute.size:not(.grout.colour) .term:not(.disabled)' ).first().addClass( 'selected' );
            size = $( '.product-form .attribute.size:not(.grout.colour) .term:not(.disabled)' ).first().attr( 'value' );
            $( '.product .overview .content .form .blocks.three .block .fields .attributes .attribute.size:not(.grout.colour) .content .select.alt .text' ).text( size );
        }
        let variant = null;
        let other_variants = [];
        if ( urlParams.get( 'variant' ) ) {
            let variant_id = urlParams.get( 'variant' );
            let index = variants.findIndex( item => item.id == variant_id );
            if ( index != -1 ) {
                variant = variants[index];
                if ( $( '.product-form .attribute.size:not(.grout.colour)' ).length ) {
                   size = variant.option2;
                   other_variants = variants.filter(item => item.options.includes( colour ) && item.options.includes( size ));   
                } else {
                    other_variants = variants.filter(item => item.options.includes( colour ));
                }
                other_variants.forEach(item => {
                    $( '.product-form .attribute.weight .term[data-variant_id="' + item.id + '"]' ).removeClass( 'hidden' );
                });
                $( '.product .overview .content .form .blocks.three .block .fields .attributes .attribute.size:not(.grout.colour) .content .select.alt .text' ).text( size );
                $('.product .overview .content .form .blocks.three .block .fields .attributes .attribute.size:not(.grout.colour) .content .modal .content .terms .term').removeClass( 'selected' );
                $('.product .overview .content .form .blocks.three .block .fields .attributes .attribute.size:not(.grout.colour) .content .modal .content .terms .term[value="' + size + '"]').addClass( 'selected' ); 
                
                if ( $( '.grout.colour' ).length ) {
                    let grout_index = window.productOptions.findIndex(item => item == 'Grout Colour' );
                    let grout = variant.options[grout_index];
                    $( '.product .overview .content .form .blocks.three .block .fields .attributes .attribute.grout.colour .content .select.alt .text' ).text( grout );
                    $( '.product .overview .content .form .blocks.three .block .fields .attributes .attribute.grout.colour .content .select.alt .swatch' ).css({'background-color': $( '.product .overview .content .form .blocks.three .block .fields .attributes .attribute.grout.colour .modal .terms .term[value="' + grout + '"] .swatch' ).css( 'background-color' ) });

                    $( '.product .overview .content .form .blocks.three .block .fields .attributes .attribute.grout.colour .modal .terms .term' ).removeClass( 'selected' );
                    $( '.product .overview .content .form .blocks.three .block .fields .attributes .attribute.grout.colour .modal .terms .term[value="' + grout + '"]' ).addClass( 'selected' );
                }
            }
        } else {
            if ( size ) {
               other_variants = variants.filter(item => item.options.includes( colour ) && item.options.includes( size ));   
            } else {
                other_variants = variants.filter(item => item.options.includes( colour ));
            }
            if ( other_variants.length == 0 ) {
                other_variants = variants;
            }
            other_variants.forEach(item => {
                $( '.product-form .attribute.weight .term[data-variant_id="' + item.id + '"]' ).removeClass( 'hidden' );
            });
            variant = other_variants[0];
            variant = variant ? variant : variants[0];
        }
        updateBanner( variant ); 
        $('.product .weight.alt .select.alt .text').text( variant.option3 );
        $( '.product-form .attribute.weight .term[data-variant_id="' + variant.id + '"]' ).addClass( 'selected' );   
    }

    function updateBanner( variant ) {
        videosSlides = {};
        if ( variant.available ) {
            $( '#add-to-bag' ).removeAttr( 'disabled' ).removeClass( 'disabled' ).find( '.text' ).text( 'Add To Bag' );   
        } else {
            $( '#add-to-bag' ).attr( 'disabled', true ).addClass( 'disabled' ).find( '.text' ).text( 'Sold Out' ); 
        }
        let images = variant.images;
      
        if ( swiperProductOne ) {                    
            swiperProductOne.removeAllSlides(); 
        }
        const numbersToWords = Utils.numberToWords();
        let $slides = [];                    
        images.forEach((image, i) => { 
            let image_theme = 'default';
            if ( image.includes( 'DB_' ) || image.includes( '-DB.' ) ) {
                image_theme = 'dark';
            } else if ( image.includes( '-LB_' ) || image.includes( '-LB.' ) ) {
                image_theme = 'light';
            }
            const $slide = `<div class="slide ${numbersToWords[i]}">                
                  <div class="overlay"></div>                
                  <div class="content">                                        
                      <div class="image swiper-zoom-target active" data-variant-pos="${i}" role="img" data-image="${( image.includes( 'T2A' ) ? 'background' : 'default' )}" style="background-image: url('${image}')" data-theme="${image_theme}"></div>
                  </div>                
              </div>`;
            $slides.push( $slide );
        });
        if ( 'videos' in variant ) {
            $('.product .banner .content .slider .button.video').removeClass( 'hidden' );
            variant.videos.forEach((video, i) => {
                $slides.push(
                    `<div class="slide video${(i == variant.videos.length - 1 ? ' last' : '')}" data-variant_id="${variant.id}">
                        <div class="overlay"></div>
                        <div class="content">
                          <div class="video">
                              <iframe 
                                  src="${video}" 
                                  width="100%" 
                                  height="500px" 
                                  frameborder="0" 
                                  allow="fullscreen; picture-in-picture; autoplay" 
                                  allowfullscreen>
                              </iframe>
                          </div>
                        </div>
                      </div>`
                ); 
            });
            $('.product .banner .content .slider .button.video .button.small.alt.view .text').text( 'Video' + ( variant.videos.length > 1 ? 's' : '' ) );
        }
        if ( swiperProductOne ) {
            swiperProductOne.appendSlide( $slides );
            swiperProductOne.slideTo( 1, 0 );
        }
        $( '.product .images .content .sections .section.one .blocks .block .image' ).css( 'background-image', 'url(' + images[1] + ')' );
        $( '.product .images .content .sections .section.two .blocks .block .image' ).css( 'background-image', 'url(' + images[2] + ')' );   
        setTimeout(() => {
          $( 'form[action*="/cart/add"] select[name="id"]' ).val( variant.id ); 
          if ( 'videos' in variant ) {
              $( '.product .banner .content .slider .button.video' ).removeClass( 'two' );
              $( '.product .banner .content .slider .button.video' ).addClass( 'one' );
          } else {
              $( '.product .banner .content .slider .button.video' ).removeClass( 'one' );
              $( '.product .banner .content .slider .button.video' ).addClass( 'two' );
              $('.product .banner .content .slider .button.video').addClass( 'hidden' );
          }
          buildBuyNowButton( variant.id );
        }, 100);
    }

    $( '.product-form__single-selector' ).click(function() {
        setTimeout(() => {
            updatePriceDisplay();
        }, 102);
    });

    function updatePriceDisplay() {
        let product_id = (new URLSearchParams($( 'form[action*="/cart/add"]' ).serialize())).get( 'id' );             
        if ( product_id ) {
            let index = variants.findIndex(item => item.id == product_id);
            if ( index >= 0 ) {
                let variant = variants[index];
                let price = window.theme.currencySymbol + ( variant.price / 100 ).toString();
                $( '.product .overview .content .blocks.two .block .price .text' ).text( price );

                /* let $nav = $( '.navigation.active .content .links ul.two' );
                let lastNav = $nav.find( 'li:last-child' ).html();
                console.log('log lastNav', lastNav)
                console.log('log options', variant.options)
                if ( variant.options.length ) {
                    console.log('log it')
                    $nav.html( '' );
                    variant.options.forEach(item => {
                        $nav.append( `<li><a>${item}</a></li>` );
                    });
                    $nav.append( 
                        `<li>${price}</li>
                        <li>${lastNav}</li>` 
                    );
                } */
                
            }
        }
    }

    function buildBuyNowButton( product_id = null ) {
        let quantity = $( 'input[name="quantity"]' ).val();
        if ( ! product_id ) {
            product_id = (new URLSearchParams($( 'form[action*="/cart/add"]' ).serialize())).get( 'id' );   
        }
        if ( ! $( '#add-to-bag' ).hasClass( 'disabled' ) ) {
            $( '.buy' ).removeClass( 'hidden' );
            $( '.buy a' ).attr( 'href', window.theme.shopUrl + '/cart/' +  product_id + ':' + quantity );
        } else {
            $( '.buy' ).addClass( 'hidden' );
        }
    }

    $( '.banner .slide.one .content' ).find( '[data-variant-pos="' + $( '.size .modal .selected' ).data( 'variantPos' ) +'"' ).addClass( 'active' );
    $( '.banner .slide.two .content' ).find( '[data-variant-pos="' + $( '.size .modal .selected' ).data( 'variantPos' ) +'"' ).addClass( 'active' );
    if ( $( '.attribute .modal .product-form__single-selector.selected' ).length == 0 ) {
        $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="0"' ).attr( 'src', $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="0"' ).data( 'videoSrc' ) );
        $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="0"' ).addClass( 'active' );
    } else {
        let variantPos = $( '.attribute .modal .product-form__single-selector.selected' ).data( 'variantPos' );
        variantPos = ! variantPos ? 0 : variantPos;
        $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="' + variantPos +'"' ).attr( 'src', $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="' + variantPos +'"' ).data( 'videoSrc' ) );
        $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="' + variantPos +'"' ).addClass( 'active' );
    }
    
    $( '.attribute .product-form__single-selector' ).click(function(e) {
        var variantPos = $(this).data( 'variantPos' ) || 0;
        history.pushState( null, null, '?variant=' + variants[variantPos].id );
        if ( [ 'A5 Peel & Stick Sample' ].includes( $( 'body' ).data( 'product_type' ) ) ) {              
            location.reload();
        }
        if ( e.currentTarget.className.includes( 'disabled' ) ) {
            return;
        }          
        if ( $(this).closest( '.product-form__option' ).hasClass( 'weight' ) && ! $(this).closest( '.product-form__option' ).hasClass( 'alt' ) ) {
        } else {            
            updateBanner( variants[ variantPos ] );
            $( '.banner .slide.last .content .video .active' ).attr( 'src', '' );
            $( '.banner .slide.last .content .video .active' ).removeClass( 'active' );
            $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="' + variantPos +'"' ).attr( 'src', $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="' + variantPos +'"' ).data( 'videoSrc' ) );
            $( '.banner .slide.last .content .video' ).find( '[data-variant-pos="' + variantPos +'"' ).addClass( 'active' );
            if ( $( '.banner .slider .button.video.mute.two' ).length != 0 ) {
                $( '#video[data-variant-pos="' + $( '.size .modal .selected' ).data( 'variantPos' ) + '"' ).on( 'load', function() {
                    variantPos = parseInt( $( '.size .modal .selected' ).data( 'variantPos' ) );
                    var player = new Vimeo.Player( $( '#video[data-variant-pos="' + variantPos + '"') );
                    player.setMuted( true );
                });
            } else if ( $( '.banner .slider .button.video.unmute.two' ).length != 0 ) {
                variantPos = parseInt( $( '.size .modal .selected' ).data( 'variantPos' ) );
                $( '#video[data-variant-pos="' + variantPos + '"' ).on( 'load', function() {
                    variantPos = parseInt( $( '.size .modal .selected' ).data( 'variantPos' ) );
                    var player = new Vimeo.Player( $( '#video[data-variant-pos="' + variantPos + '"') );
                    player.setMuted( false );
                });
            }
        }  
        if ( $(this).closest( '.attribute.color.product-form__option' ).length ) {
            let $container = $(this).closest( '.attribute.color.product-form__option' );
            let text = $( '.title h5', this ).text();
            $container.find( '.select.alt .text' ).text( text );
            $container.find( '.select.alt .swatch' ).css( 'background-image', e.target.style.backgroundImage );

        }
    });

   $( '.product-form .quantity-selector__button' ).on( 'click', function () {         
       let quantity = parseInt( $( '.quantity-selector__value' ).val(), 10 );
       quantity = isNaN(quantity) ? 0 : quantity;
       quantity += $(this).hasClass('plus') ? 1 : -1;
       quantity = Math.max(quantity, 1);
       $( '.quantity-selector__value' ).val( quantity );
       buildBuyNowButton();
    });
  
    Utils.generateProductReviews( '.related .slider' );
  
    const swiper_breakpoints = {
          0: {
              spaceBetween: 12,
              slidesPerView: 2,
          },
          900: {
              spaceBetween: 12,
              slidesPerView: 1,
          },
          1025: {
              spaceBetween: 14,
              slidesPerView: 2,
          }
      };
  
    Utils.generateProductsSlider( '.product .overview .blocks.complementary .slider', swiper_breakpoints );
    
    saveRecentlyViewedProducts();
  
    function saveRecentlyViewedProducts() {
         var items = JSON.parse( localStorage.getItem('recentlyViewedProducts') || '[]' ),
            currentProductId = window.currentProductId;
        if ( ! items.includes( currentProductId ) ) {
            items.unshift(currentProductId);
        }
        try {
            localStorage.setItem( 'recentlyViewedProducts', JSON.stringify( items.slice(0, 18) ) );
        } catch (error) {
        }
    }
      
    if ( localStorage.getItem( 'to_show_bag' ) ) {
        $( '.bag.main' ).addClass( 'delay' );
        setTimeout(function() {
            $( '.bag.main').addClass( 'active' );
        }, 100 ); 
        localStorage.removeItem( 'to_show_bag' )
    }      

});